<template>
    <v-col cols="12" class="border border-radius px-7 pt-7 pb-4 mb-5">
        <h4 class="font-weight-medium">{{ feature.title }}</h4>
        <p class="m-0 p-clr">{{ feature.description }}
            <span v-if="feature.redirect_url" class="d-block">Redirect to {{ feature.redirect_url }}</span>
        </p>
        <v-row class="mt-5 mx-0">
            <v-chip class="rounded mr-3 mb-3 px-6" v-for="(items, i) in feature.roles" :key="i">
                <span>{{ items }}</span>
            </v-chip>
        </v-row>
        <v-row class="mt-4">
            <v-col  cols="12" md="6" sm="6">
                <div v-for="img, index in feature.image_url" :key="index" class="d-flex mt-3" @click="()=>{attachments= img ;openImageModal = true}">
                    <img src="/img/avatars/014-gallery.png" alt="default-user" class="mr-2" style="width:22px;" />
                    <span>{{ getFilenameFromURL(img) }}</span>
                    <span class="pl-3 font-weight-bold text-success cursor">View</span>
                </div>
            </v-col>
            <v-col v-if="action != 'view'" cols="12" md="6" sm="6" class="d-flex justify-end">
                <v-btn color="error" class="btn mr-4 px-6 py-5" @click="$emit('removeFeature')">Delete</v-btn>
                <v-btn color="success" class="btn mr-0 px-6 py-5" @click="$emit('editFeature', feature)">Edit</v-btn>
            </v-col>
        </v-row>
        <div>
            <image-preview
            @close="openImageModal = false"
            v-if="openImageModal"
            :openImageModal="openImageModal"
            :source="attachments"
            ></image-preview>
        </div>
    </v-col>
</template>
<script>
export default {
    props: ["feature", "action"],
    data() {
        return {
            openImageModal: false,
            attachments:'',
        }
    },
    components:{
    "image-preview": () => import("@/components/modals/imagePreview.vue"),
    },
    methods: {
        getFilenameFromURL(url) {
            const parsedUrl = new URL(url);
            const pathname = parsedUrl.pathname;
            return pathname.substring(pathname.lastIndexOf("/") + 1);
        },
    }
}
</script>